import React, { useContext, useEffect, useState, useRef } from "react";
import UploadForm from "./UploadForm";
import "../../styles/fonts.css";
import { subjects } from "../layouts/subjects";
//import "../upload/upload.css";
const AcadUpload = (props) => {
  const newTag = useRef("");

  const [info, setInfo] = useState({
    name: "",
    branch: "",
    course: "",
    type: "",
    subject: "misc",
    url: "",
    author: "",
    resourcetype: "not approved",
    description: "",
    tags: [],
  });

  const { name, description, year, course, branch, tags, author, url } = info;
  const onChange = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value });
  };
  const resetInfo = () => {
    setInfo({
      name: "",
      branch: "",
      owner: "",
      type: "",
      course: "",
      url: "",
      resourcetype: "not approved",
      author: "",
      subject: "misc",
      description: "",
      tags: [],
    });
  };
  const setUrl = (url) => {
    setInfo({ ...info, url });
  };
  const setType = (type) => {
    setInfo({ ...info, type });
  };
  const setResourceType = (resourcetype) => {
    setInfo({ ...info, resourcetype });
  };
  const subjectChange = (e) => {
    setInfo({ ...info, subject: e.target.value.split("-")[0] });
  };
  const addTag = (e) => {
    let inp = e.target.value;
    let lastChar = inp.substring(inp.length - 1);
    if (lastChar === " " && inp !== " ") {
      inp = inp.slice(0, -1);
      setInfo({ ...info, tags: [...tags, inp] });
      newTag.current.value = "";
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (name && author && url) {
      const res = await props.addToFirestore(info, "academics");
      resetInfo();
    }
  };

  const deleteTag = (e) => {
    tags.splice(e.target.name, 1);
    setInfo({ ...info, tags: tags });
  };
  return (
    <div className='App m-2 p-2 mx-auto'>
      <div className='title row'>
        <h2 className='m-2 text-center upperfont col-12'>Upload Here</h2>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleVideoTags'>Title</label>
          <input
            type='text'
            className='form-control simplefont text-center'
            id='name'
            name='name'
            value={name}
            placeholder='title'
            onChange={onChange}
            required
          />
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleVideoTags'>Author</label>
          <input
            type='text'
            className='form-control simplefont text-center'
            id='author'
            name='author'
            value={author}
            placeholder='Video Made/Presented by...'
            onChange={onChange}
            required
          />
        </div>
        <div className='form-group col-11 col-xl-5 col-lg-5 col-md-5 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleCourse'>Course</label>
          <select
            id='exampleCourse'
            name='course'
            value={course}
            onChange={onChange}
            className='form-control simplefont text-center'
          >
            <option value='' defaultValue classname='text-center'>
              Select...
            </option>
            <option value='BTech' classname='text-center'>
              B. Tech.
            </option>
            <option value='MTech' classname='text-center'>
              M.Tech.
            </option>
            <option value='MSc' classname='text-center'>
              M.Sc.
            </option>
            <option value='Phd' classname='text-center'>
              Ph.D.
            </option>
            <option value='dB+M' classname='text-center'>
              Dual BTech + Masters
            </option>
            <option value='dM+P' classname='text-center'>
              Dual Masters + Phd
            </option>
          </select>
        </div>
        <div className='form-group col-11 col-xl-5 col-lg-5 col-md-5 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleYear'>Year</label>
          <select
            id='exampleYear'
            name='year'
            value={year}
            onChange={onChange}
            className='form-control simplefont text-center'
          >
            <option value='' defaultValue>
              Select...
            </option>
            <option value='1'>1</option>
            <option value='2'>2</option>
            <option value='3'>3</option>
            <option value='4'>4</option>
            <option value='5'>5</option>
          </select>
        </div>
        <div className='form-group col-11 col-xl-5 col-lg-5 col-md-5 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleBranch'>Branch</label>
          <select
            id='exampleBranch'
            name='branch'
            value={branch}
            onChange={onChange}
            className='form-control simplefont text-center'
          >
            <option value='' defaultValue>
              Select...
            </option>
            <option value='CSE'>CSE - Computer Sc. Eng</option>
            <option value='EE'>EE - Electrical Eng</option>
            <option value='ME'>ME - Mechanical Eng</option>
            <option value='CE'>CE - Civil Eng</option>
            <option value='MEMS'>
              MEMS - Metallurgical and Mining Science
            </option>
          </select>
        </div>
        <div className='form-group col-11 col-xl-5 col-lg-5 col-md-5 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='subjectList'>Subject</label>
          <input
            list='browsers'
            name='browser'
            id='subjectList'
            onChange={subjectChange}
            className='form-control simplefont text-center'
            data-toggle='tooltip'
            data-placement='right'
            placeholder='Enter a subject from the drop down to appear in search results for
            subject'
          />

          <datalist id='browsers'>
            {subjects.BTech.map((item) => (
              <option value={item} />
            ))}
          </datalist>
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='description'>Description</label>
          <textarea
            type='description'
            className='form-control simplefont text-center'
            id='description'
            name='description'
            rows='3'
            value={description}
            placeholder='description'
            onChange={onChange}
          ></textarea>
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='description' className='text-center col-11'>
            Tags
          </label>
          {tags &&
            tags.map((item, index) => (
              <input
                type='button'
                name={index}
                value={item}
                className='fontcool col-2 bg-dark rounded-pill text-light mx-auto'
                aria-label='Close'
                onClick={deleteTag}
              />
            ))}
          <div className='input-group mb-3'>
            <input
              ref={newTag}
              onChange={addTag}
              type='text'
              className='form-control simplefont  text-center'
              placeholder='Add tags and press space'
            />{" "}
          </div>
        </div>
      </div>

      <UploadForm
        info={info}
        collection='academics'
        setUrl={setUrl}
        setResourceType={setResourceType}
        setType={setType}
      />
      <a className='nolinklook' onClick={onSubmit}>
        <button className='slantfont btn btn-block size09 btn-outline-success mx-auto my-4'>
          UPLOAD
        </button>
      </a>
    </div>
  );
};

export default AcadUpload;
